import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { useSEO } from "../lib/useSEO";

export default function NotFound() {
  useSEO("Page not found", "The page you were looking for could not be found.", { noindex: true });
  return (
    <div className="min-h-screen bg-white" data-testid="not-found-page">
      <Navbar />
      <section className="py-24 lg:py-32 text-center">
        <div className="mx-auto max-w-xl px-6">
          <div className="uppercase-label mb-5">404</div>
          <h1 className="font-display text-4xl text-[#0A2540] font-semibold" data-testid="not-found-heading">
            We can&apos;t find that page.
          </h1>
          <p className="mt-4 text-[#6B7280]">It may have moved or no longer exists.</p>
          <div className="mt-7 flex justify-center gap-3">
            <Link to="/"><Button className="rounded-full h-12 px-7 bg-[#0A2540] hover:bg-[#001A3D]" data-testid="not-found-home-btn">Go home</Button></Link>
            <Link to="/blog"><Button variant="outline" className="rounded-full h-12 px-7" data-testid="not-found-blog-btn">Browse the blog</Button></Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
